import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useSEO } from "@/hooks/useSEO";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { SectorsHighlight } from "@/components/SectorsHighlight";
import { StatsSection } from "@/components/StatsSection";
import { FeaturedProducts } from "@/components/FeaturedProducts";
import { HowItWorks } from "@/components/HowItWorks";
import { SectorWizard } from "@/components/SectorWizard";
import { Benefits } from "@/components/Benefits";
import { CalculatorCTA } from "@/components/CalculatorCTA";
import { LatestArticles } from "@/components/LatestArticles";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import AdminDashboard from "@/components/AdminDashboard";
import CalculatorPage from "@/components/CalculatorPage";
import BlogPage from "@/components/BlogPage";
import BlogArticle from "@/components/BlogArticle";
import ChiSiamo from "@/components/ChiSiamo";
import SectorPage from "@/components/SectorPage";
import ProductsPage from "@/components/ProductsPage";
import ProductDetail from "@/components/ProductDetail";
import LandingPage from "@/components/LandingPage";
import TrackingScripts from "@/components/TrackingScripts";
import CookieBanner from "@/components/CookieBanner";
import PrivacyPage from "@/components/PrivacyPage";
import PageViewTracker from "@/components/PageViewTracker";

const SEOHead = () => {
  useSEO({
    title: "Fotovoltaico Chiavi in Mano | Hub Energia Verde per Casa e PMI",
    description: "Il tuo hub per l'energia verde: soluzioni fotovoltaiche per residenziale e PMI. Preventivi gratuiti da partner certificati in tutta Italia.",
    canonical: window.location.origin,
  });
  return null;
};

const HomePage = () => {
  const [showSelector, setShowSelector] = useState(false);

  const openSelector = () => setShowSelector(true);
  const closeSelector = () => setShowSelector(false);

  return (
    <div className="min-h-screen" data-testid="home-page">
      <SEOHead />
      <Navbar onConfigureClick={openSelector} />
      <HeroSection onConfigureClick={openSelector} />
      <SectorsHighlight />
      <StatsSection />
      <FeaturedProducts />
      <Benefits onConfigureClick={openSelector} />
      <HowItWorks />
      <CalculatorCTA />
      <LatestArticles />
      <Testimonials />
      <FAQ />
      <Footer />

      {showSelector && (
        <SectorWizard onClose={closeSelector} />
      )}
    </div>
  );
};

function App() {
  return (
    <div>
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: { fontFamily: "DM Sans, sans-serif" },
        }}
      />
      <TrackingScripts />
      <BrowserRouter>
        <PageViewTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/calcolatore" element={<CalculatorPage />} />
          <Route path="/residenziale" element={<SectorPage sectorId="residenziale" />} />
          <Route path="/pmi" element={<SectorPage sectorId="pmi" />} />
          <Route path="/prodotti" element={<ProductsPage />} />
          <Route path="/prodotti/:slug" element={<ProductDetail />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/promo/:slug" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <CookieBanner />
    </div>
  );
}

export default App;
